import React from 'react'

import Base from '../_Base'

const CsCross = (props) => (
  <Base width="34" height="34" viewBox="0 0 34 34" {...props}>
    <path
      fillRule="evenodd"
      d="M19.003 17l7.499-7.498a1.415 1.415 0 000-2.004 1.415 1.415 0 00-2.003 0L17 14.997 9.502 7.498a1.415 1.415 0 00-2.003 0 1.415 1.415 0 000 2.004L14.997 17l-7.498 7.498a1.415 1.415 0 000 2.004c.516.516 1.402.6 2.003 0L17 19.003l7.499 7.499a1.417 1.417 0 002.003 0 1.415 1.415 0 000-2.004L19.003 17z"
    />
  </Base>
)

export default CsCross
